import animation, { cubicBezierBackgroundColor } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  smallcapsBold13Styles,
  smallcapsBold14Styles,
} from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

import AnimatedDash, { animationStyles } from "../common/AnimatedDash"

const GatsbyLink = styled(Link)`
  text-decoration: none !important;
`

const ExternalLink = styled.a`
  text-decoration: none !important;
`

const whiteProps = `
  color: ${colors.black};
  background-color: ${colors.white};
  border: solid 1px ${colors.black};

  &:active {
    background-color: ${colors.white};
  }

  @media ${breakpoints.laptop} {
    color: ${colors.black};

    &:hover {
      background-color: ${colors.white};
    }
  }
`
export const Button = styled.span<any>`
  ${smallcapsBold13Styles}
  align-items: center;
  justify-content: space-between;
  display: flex;
  position: relative;
  height: 48px;
  width: 100%;
  padding: 0 24px;
  line-height: 22px;
  color: ${colors.offWhite};
  background-color: ${colors.black};
  border-radius: 2px;
  border: none;
  transition: background-color ${animation.medium} ${cubicBezierBackgroundColor};
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:active {
    background-color: ${colors.black};
    transition: none;
  }

  ${animationStyles}

  @media ${breakpoints.laptop} {
    ${smallcapsBold14Styles}
    color: ${colors.offWhite};
    line-height: 22px;

    &:hover {
      background-color: ${colors.hoverBlack};
    }
  }

  ${({ $buttonStyles }) => ($buttonStyles ? $buttonStyles : "")}
  ${({ $white }) => ($white ? whiteProps : "")}
`

export const TextWrapper = styled.span`
  padding: 4px 24px 0 0;
`

export interface LinkButtonProps {
  buttonStyles?: string
  className?: string
  external?: boolean
  noDash?: boolean
  target?: string
  text: string
  to: string
  white?: boolean
}

const LinkButton: React.FC<LinkButtonProps> = ({
  buttonStyles,
  className,
  external,
  noDash,
  target,
  text,
  to,
  white,
}) => {
  const children = (
    <Button $buttonStyles={buttonStyles} $white={white}>
      <TextWrapper>{text}</TextWrapper>
      {!noDash && <AnimatedDash color={white ? colors.black : colors.white} />}
    </Button>
  )
  return external ? (
    <ExternalLink
      aria-label={text}
      className={className}
      href={to}
      rel="noopener"
      target={target || "_blank"}
    >
      {children}
    </ExternalLink>
  ) : (
    <GatsbyLink
      aria-label={text}
      className={className}
      target={target}
      to={to || ""}
    >
      {children}
    </GatsbyLink>
  )
}

export default LinkButton
